<template>
  <div class="login container fontSize_14 color_333">
    <theHeader></theHeader>
    <div class="main text_center vertical_middle">
      <div :class="'left ' + (userType == 4 && !isLogin ? 'mb_600' : '')"></div>
      <div class="right">
        <div v-if="isLogin" class="login">
          <h3 class="header fontSize_18 color_333">{{userType == 2? '客户登录': (userType == 3? '服务商登录':'货代服务商登录')}}</h3>
          <div class="login_area">
            <div class="login_wrap user_wrap mb_20">
              <input
                v-model="loginParams.username"
                type="text"
                class="login_txt username_txt box_sizing"
                placeholder="请输入用户名"
              />
            </div>
            <div class="login_wrap password_wrap">
              <input
                v-model="loginParams.password"
                type="password"
                class="login_txt password_txt box_sizing"
                placeholder="请输入密码"
              />
            </div>
          </div>
          <div class="mb_20">
            <div @click="handleLogin" class="btn text_center color_fff">登录</div>
          </div>
          <div class="tips flex justify_end">
            还没有帐号，
            <span @click="registernow" class="color_2e5597">现在注册</span>
          </div>
          <!-- 版权 -->
          <p class="copyright text_center fontSize_14" style="right: 700px;position: fixed;bottom: 30px;">© 2021-2023 qzztcn.com版权所有    信息产业部备案:
            <img src="/static/img/beian-bg.png" style="width: 16px;height: 16px;"><span><a style="color:skyblue;"
            target="_blank" rel="noopener" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">闽ICP备06047499号-1</a></span></p>
        </div>
        <div v-if="!isLogin" class="register">
          <h3 class="header fontSize_18 color_333">{{userType == 2? '注册正和港用户':(userType == 3? '注册正和港服务商':'注册正合港货代服务商')}}</h3>
          <el-form :model="registerParams" label-position="right" label-width="180px"   :rules="registerRules" ref="registerParams">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="registerParams.username" type="text" placeholder="用户名"></el-input>
                </el-form-item>
                <el-form-item label="密码"  prop="password">
                  <el-input v-model="registerParams.password" type="password" placeholder="6-12位字符及数字"></el-input>
                </el-form-item>
                <el-form-item label="再次确认密码"  prop="password_confirm">
                  <el-input
                    v-model="registerParams.password_confirm"
                    type="password"
                    placeholder="6-12位字符及数字"
                  ></el-input>
                </el-form-item>
                <el-form-item label="E-mail" v-if="userType != 2" prop="email">
                  <el-input v-model="registerParams.email" type="text" placeholder="E-mail"></el-input>
                </el-form-item>
                <el-form-item  v-if="userType != 4" label="手机号码" prop="phone" >
                  <el-input v-model="registerParams.phone" type="text" placeholder="手机号码"  ></el-input>
                </el-form-item>
                <el-form-item label="企业名称/个人姓名" v-if="userType == 2" prop="userInfo.company"   >
                  <el-input v-model="registerParams.userInfo.company" type="text" placeholder="企业名称/个人姓名" ></el-input>
                </el-form-item>
                <el-form-item label="企业名称" v-if="userType != 2" prop="userInfo.company"  >
                  <el-input v-model="registerParams.userInfo.company" type="text" placeholder="企业名称" ></el-input>
                </el-form-item>
                <el-form-item label="企业所在地"  v-if="userType != 2" prop="location">
                  <el-cascader
                    v-model="registerParams.location"
                    :options="address"
                    :props="{
                      value: 'label',
                      label: 'label',
                    }"
                    placeholder="请选择您公司营业执照上的联系地址"
                  ></el-cascader>
                </el-form-item>

                <el-form-item label="区/县/镇"  v-if="userType != 2" prop="userInfo.address">
                  <el-input
                    v-model="registerParams.userInfo.address"
                    type="text"
                    placeholder="请尽量填写详细，否则可能会报名失败"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人"   prop="userInfo.contact">
                  <el-input v-model="registerParams.userInfo.contact" type="text" placeholder="联系人"></el-input>
                </el-form-item>
                <el-form-item   v-if="userType != 2" :label="userType == 4 ? '法人电话' : '联系电话'"  prop="userInfo.telephone">
                  <el-input v-model="registerParams.userInfo.telephone" type="text" placeholder="联系电话"></el-input>
                </el-form-item>
                <el-form-item label="统一社会信用代码"   v-if="userType == 2"  >
                  <el-input v-model="registerParams.userInfo.organization" type="text" placeholder="统一社会信用代码"></el-input>
                </el-form-item>
                <el-form-item  v-if="userType == 2" >
                <span slot="label">
<!--                  <span class="red">*</span>-->
                  营业执照
                </span>
              <div class="el-upload-list el-upload-list--picture-card" v-if="license">
                <div class="el-upload-list__item is-success">
                  <img class="avatar" :src="license" alt="">
                  <label class="el-upload-list__item-status-label">
                    <i class="el-icon-upload-success el-icon-check"></i>
                  </label>
                  <span class="el-upload-list__item-actions">
                        <!-- 放大图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-zoom-in" @click.stop="licensePreview"></i>
                        </span>
                    <!-- 删除图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-delete" @click.stop="licenseRemove"></i>
                        </span>
                    </span>
                </div>
              </div>
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                accept="image/*"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="licenseUpload"
                v-if="!license"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="licenseVisible">
                <img width="100%" :src="license" alt />
              </el-dialog>
            </el-form-item>
            <!-- 注册货代服务商时多填写的信息 -->
            <span v-if="userType == 4">
              <el-form-item label="法人姓名"  prop="userInfo.corporation">
                <el-input v-model="registerParams.userInfo.corporation" type="text" placeholder="法人姓名"></el-input>
              </el-form-item>
              <el-form-item label="法人身份证"  prop="userInfo.idcard">
                <el-input v-model="registerParams.userInfo.idcard" type="text" placeholder="法人身份证"></el-input>
              </el-form-item>
              <el-form-item label="企业信用代码"  prop="userInfo.registration">
                <el-input v-model="registerParams.userInfo.registration" type="text" placeholder="企业信用代码"></el-input>
              </el-form-item>
              <el-form-item label="税局海关代码"  prop="userInfo.custom">
                <el-input v-model="registerParams.userInfo.custom" type="text" placeholder="税局海关代码"></el-input>
              </el-form-item>
              <el-form-item label="收款银行"  prop="userInfo.bank">
                <el-input v-model="registerParams.userInfo.bank" type="text" placeholder="收款银行"></el-input>
              </el-form-item>
              <el-form-item label="收款账号"  prop="userInfo.bank_account">
                <el-input v-model="registerParams.userInfo.bank_account" type="text" placeholder="收款账号"></el-input>
              </el-form-item>
              <el-form-item >
                <span slot="label">
                  <span class="red">*</span>
                  营业执照
                </span>
                <div class="el-upload-list el-upload-list--picture-card" v-if="license">
                  <div class="el-upload-list__item is-success">
                    <img class="avatar" :src="license" alt="">
                    <label class="el-upload-list__item-status-label">
                        <i class="el-icon-upload-success el-icon-check"></i>
                    </label>
                    <span class="el-upload-list__item-actions">
                        <!-- 放大图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-zoom-in" @click.stop="licensePreview"></i>
                        </span>
                      <!-- 删除图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-delete" @click.stop="licenseRemove"></i>
                        </span>
                    </span>
                  </div>
                </div>
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="licenseUpload"
                  v-if="!license"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="licenseVisible">
                  <img width="100%" :src="license" alt />
                </el-dialog>
              </el-form-item>
              <el-form-item >
                <span slot="label">
                  <span class="red">*</span>
                  货代许可证
                </span>
                <div class="el-upload-list el-upload-list--picture-card" v-if="freight_license">
                  <div class="el-upload-list__item is-success">
                    <img class="avatar" :src="freight_license" alt="">
                    <label class="el-upload-list__item-status-label">
                        <i class="el-icon-upload-success el-icon-check"></i>
                    </label>
                    <span class="el-upload-list__item-actions">
                        <!-- 放大图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-zoom-in" @click.stop="freightLicensePreview"></i>
                        </span>
                      <!-- 删除图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-delete" @click.stop="freightLicenseRemove"></i>
                        </span>
                    </span>
                  </div>
                </div>
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="freightLicenseUpload"
                  v-if="!freight_license"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="freight_licenseVisible">
                  <img width="100%" :src="freight_license" alt />
                </el-dialog>
              </el-form-item>
              <el-form-item >
                <span slot="label">
                  <span class="red">*</span>
                  身份证
                </span>
                <div class="el-upload-list el-upload-list--picture-card" v-if="idcardpicture">
                  <div class="el-upload-list__item is-success">
                    <img class="avatar" :src="idcardpicture" alt="">
                    <label class="el-upload-list__item-status-label">
                        <i class="el-icon-upload-success el-icon-check"></i>
                    </label>
                    <span class="el-upload-list__item-actions">
                        <!-- 放大图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-zoom-in" @click.stop="idcardpicturePreview"></i>
                        </span>
                      <!-- 删除图片 -->
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-delete" @click.stop="idcardpictureRemove"></i>
                        </span>
                    </span>
                  </div>
                </div>
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="idcardpictureUpload"
                  v-if="!idcardpicture"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="idcardpictureVisible">
                  <img width="100%" :src="idcardpicture" alt />
                </el-dialog>
              </el-form-item>
            </span>
            <div class="mt_20 mb_20">
              <div @click="handleRegister('registerParams')" class="btn text_center color_fff">{{btnname}}</div>
            </div>
            <div class="tips flex justify_end">
              <span @click="isLogin = true" class="color_2e5597">已经有了正和港帐号？立即登录</span>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <p class="copyright text_center fontSize_14"  style="right: 700px;position: fixed;bottom: 30px;">© 2021-2023 qzztcn.com版权所有    信息产业部备案:
      <img src="/static/img/beian-bg.png" style="width: 16px;height: 16px;"><span><a style="color:skyblue;"
      target="_blank" rel="noopener" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">闽ICP备06047499号-1</a></span></p>
  </div>
</template>

<script>
import theHeader from "@/components/layout/Header.vue";
import address from "../../static/js/address.js";
import config from "@/config";
import md5 from 'js-md5'; 
export default {
  components: {
    theHeader
  },
  data() {
    return {
      license: "",
      licenseVisible: false,
      freight_license: "",
      freight_licenseVisible: false,
      idcardpicture: "",
      idcardpictureVisible: false,
      baseImgUrl: config.baseImgUrl,
      uploadUrl: `${config.baseUrl}/admin/uploadimg`,
      address: address,
      userType: 2, //2代表用户端，3代表服务商端 4货代服务商
      isLogin: true, //true登录，false注册
      btnname:"立即注册",
      loginParams: {
        username: "",
        password: ""
      },
      registerParams: {
        type: "customer",
        userInfo: {}
      },
      registerRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          {
            required: true,
            message: "6-12位，只接受大小写字母及数字",
            trigger: "blur"
          }
        ],
        password_confirm: [
          {
            required: true,
            message: "6-12位，只接受大小写字母及数字",
            trigger: "blur"
          }
        ],
        email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        phone: [{ required: true, message: "请输入您的手机", trigger: "blur" }],
        "userInfo.company": [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        location: [
          { required: true, message: "请选择企业所在地", trigger: "blur" }
        ],
        "userInfo.address": [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        "userInfo.contact": [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        "userInfo.telephone": [
          { required: true, message: "请输入电话", trigger: "blur" }
        ],
        "userInfo.corporation": [
          { required: true, message: "请输入法人姓名", trigger: "blur" }
        ],
        "userInfo.idcard": [
          { required: true, message: "请输入法人身份证", trigger: "blur" }
        ],
        "userInfo.registration": [
          { required: true, message: "请输入企业信用代码", trigger: "blur" }
        ],
        "userInfo.custom": [
          { required: true, message: "请输入税局海关代码", trigger: "blur" }
        ],
        "userInfo.bank": [
          { required: true, message: "请输入收款银行", trigger: "blur" }
        ],
        "userInfo.bank_account": [
          { required: true, message: "请输入收款账号", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    $route: "routerChange"
  },
  created() {
    this.changeType();
  },
  methods: {
    routerChange() {
      this.changeType();
    },
    changeType() {
      const query = this.$route.query;
      if (query.type) {
        this.userType = Number(query.type);
        this.isLogin = true;
      }
    },
    //营业执照
    licenseUpload(res, file) {
      this.license = this.baseImgUrl + file.response.path;
      this.registerParams.userInfo.license = file.response.path;
    },
    licenseRemove(file) {
      this.license = "";
      this.registerParams.userInfo.license = "";
    },
    licensePreview() {
      this.licenseVisible = true;
    },
    //货代许可证
    freightLicenseUpload(res, file) {
      this.freight_license = this.baseImgUrl + file.response.path;
      this.registerParams.userInfo.freight_license = file.response.path;
    },
    freightLicenseRemove(file) {
      this.freight_license = "";
      this.registerParams.userInfo.freight_license = "";
    },
    freightLicensePreview() {
      this.freight_licenseVisible = true;
    },
    //身份证
    idcardpictureUpload(res, file) {
      this.idcardpicture = this.baseImgUrl + file.response.path;
      this.registerParams.userInfo.idcardpicture = file.response.path;
    },
    idcardpictureRemove(file) {
      this.idcardpicture = "";
      this.registerParams.userInfo.idcardpicture = "";
    },
    idcardpicturePreview() {
      this.idcardpictureVisible = true;
    },
    // isService () {
    //   this.userType = 3;
    //   this.isLogin = true
    // },
    // isUser () {
    //   this.userType = 2;
    //   this.isLogin = true
    // },
    // isFreight(){
    //   this.userType = 4;
    //   this.isLogin = true
    // },
    //获取随机数
    randomString(length){
      var result = '';  
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';  
      var charactersLength = characters.length;  
      for (var i = 0; i < length; i++) {  
          result += characters.charAt(Math.floor(Math.random() * charactersLength));  
      }  
      return result;  
    },
     // 将 Unicode 字符串进行编码
    base64EncodeUnicode(str) {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
    },
    handleLogin() {
      let loginParams = this.loginParams;
      let userType = this.userType;
      loginParams.type =
        userType == 2
          ? "customer"
          : userType == 3
            ? "provider"
            : "provider_freight";
      if (!loginParams.username) {
        this.$message.warning("请输入您的账号");
        return;
      }
      if (!loginParams.password) {
        this.$message.warning("请输入您的密码");
        return;
      }
      // const base64Password = btoa(loginParams.password);
      // console.log(loginParams.password,base64Password,md5(base64Password),'loginParams.password')
      const salt = this.randomString(5)
      const passwordStr = loginParams.password+"{"+salt+"}"
      const usernameStr = loginParams.username+"{"+salt+"}"
      const newPassword = this.base64EncodeUnicode(this.base64EncodeUnicode(passwordStr))
      const newUsername = this.base64EncodeUnicode(this.base64EncodeUnicode(usernameStr))
      // console.log(salt,newPassword,usernameStr)
      let obj = {
        ...loginParams,
        password:newPassword,
        username:newUsername 
      }
      // 用户登录
      this.$axios.post("/user/login/v1", obj).then(res => {
        if (res.data.result) {
          res = res.data;
          sessionStorage.setItem("userId", res.uid);
          sessionStorage.setItem("token", res.token);
          sessionStorage.setItem("isLogin", true);
          sessionStorage.setItem("user", JSON.stringify(res.user));
          sessionStorage.setItem("userType", userType);
          this.$router.push("/user/userIndex");
        } else { 
          if(res.data.checkState==2){
            res.data.user.password=this.loginParams.password
            res.data.user.password_confirm=this.loginParams.password
            res.data.user.location=res.data.user.userInfo.location.split(" ")
            this.isLogin=false
            this.registerParams= res.data.user
            this.btnname="重新提交审核"
          }
          this.$message.warning(res.data.info);
        }
      });
    },
    // 现在注册
    registernow(){
      this.isLogin=false
      this.btnname="立即注册"
      this.registerParams= {
        type: "customer",
        userInfo: {}
      }
    },
    handleRegister(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let registerParams = this.registerParams;
          registerParams.type =
            this.userType == 2
              ? "customer"
              : this.userType == 3
                ? "provider"
                : "provider_freight";
          if(registerParams.location){
            registerParams.userInfo.location = registerParams.location.join(" ");
          }

          if (registerParams.password_confirm != registerParams.password) {
            this.$message.warning("两次输入的密码不同");
            return;
          }
          if (this.userType ==4 ) {
            if (!registerParams.userInfo.license) {
              this.$message.warning("请上传营业执照");
              return;
            }
            if (!registerParams.userInfo.freight_license) {
              this.$message.warning("请上传货代许可证");
              return;
            }
            if (!registerParams.userInfo.idcardpicture) {
              this.$message.warning("请上传身份证");
              return;
            }
          }
          let url="/admin/infoUser/reg"
          if(this.btnname=="重新提交审核"){
            url="/user/user/editUserInfo"
          }
          this.$axios.post(url, registerParams).then(res => {
            // if (res.status == 200) {
            //   if (res.data.erray_code == '501') {
            //     alert('该用户名已注册');
            //     return;
            //   }
            //   alert(`您已提交申请成为正和港平台${this.userType == 2 ? '客户' : '服务商'}，请耐心等待审核通过......`);
            //   this.isLogin = true;
            // }
            if (res.data.result == false) {
              alert("注册失败,用户名已存在");
              return;
            } else {
              alert(
                `您已提交申请成为正和港平台${
                  this.userType == 2
                    ? "客户"
                    : this.userType == 3
                      ? "服务商"
                      : "货代服务商"
                }，请耐心等待审核通过......`
              );
              this.isLogin = true;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}

input {
  background-color: transparent;
}

.login {
  position: relative;
  height: 100%;
}

.login_txt {
  background-repeat: no-repeat;
  background-position-x: 16px;
  background-position-y: 50%;
  border: solid 1px #dcdfe6;
  border-radius: 4px;
}

.password_wrap {
  background-image: url("../../static/img/login_password.png");
  background-repeat: no-repeat;
  background-position-x: 16px;
  background-position-y: 50%;
}

.user_wrap {
  background-image: url("../../static/img/login_user.png");
  background-repeat: no-repeat;
  background-position-x: 16px;
  background-position-y: 50%;
}

.login_txt {
  display: block;
  padding-left: 48px;
  width: 100%;
  height: 38px;
}

.color_2e5597 {
  color: #2e5597;
}

.mb_44 {
  margin-bottom: 44px;
}

.main {
  height: 100vh;
  /* position: relative; */
}
.mb_600 {
  margin-bottom: 600px;
}

.left {
  display: inline-block;
  width: 456px;
  height: 303px;
  margin-right: 100px;
  vertical-align: middle;
  background-image: url("../../static/img/login_bg.png");
  /* position: relative;
  top: 100px;
  left: 100px; */
}

.right {
  display: inline-block;
  width: 340px;
  vertical-align: middle;
}

.login_area {
  margin-bottom: 44px;
}

.header {
  margin-bottom: 46px;
  margin-top: 115px;
}

.btn {
  height: 40px;
  line-height: 40px;
  background: #2e5597;
  border-radius: 4px;
}
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue